import axios from 'axios';

import { api } from '../../../../services/api';
import { apiSensediaSegmentacao } from '../../../../services/api-sensedia-segmentacao';

export type ISegmentation = {
  cod_ano_mes_segmentacao: string;
  cod_diretoria: string;
  nme_diretoria: string;
  cod_superintendente: string;
  nme_superintendente: string;
  cod_filial: string;
  nme_filial: string;
  cod_ea: string;
  nme_gestor: string;
  cod_aa: string;
  cod_ev: string;
  cod_produtor: string;
  nme_produtor: string;
  dsc_canal: string;
  flg_corretor_novo_visod: string;
  dat_cadastro_produtor: string;
  cod_faixa_segmentacao: string;
  dsc_faixa_segmentacao: string;
  val_pontos_classificacao_segmentacao: string;
  val_premio_saude: string;
  val_churn_saude: string;
  val_score_calculado_churn_saude: string;
  pct_sinistralidade_saude: string;
  val_score_calculado_sinistralidade_saude: string;
  qtd_vida_saude_periodo_anterior: string;
  qtd_vida_saude_periodo_atual: string;
  qtd_vida_nova_saude: string;
  val_score_calculado_vida_nova_saude: string;
  pct_crescimento_vida_saude: string;
  val_score_calculado_crescimento_vida_saude: string;
  qtd_vida_odonto_periodo_atual: string;
  val_score_calculado_vida_nova_odonto: string;
  cod_faixa_segmentacao_ajustada: string;
  nme_solicitou_ajuste_segmentacao: string;
  dat_segmentacao_ajustada: string;
  flg_segmentacao_mercado: string;
  dat_execucao_segmentacao: string;
};

export const getDataSegmentationSensedia = async () => {
  try {
    const data = await apiSensediaSegmentacao.get<ISegmentation[]>(
      '/segmentacoes/indicadores-corretor',
      {}
    );
    return data;
  } catch (error: any) {
    throw new Error(error.message);
  }
};
